import React, { useEffect, useRef, useState } from 'react';
import { Input } from 'antd';
import { noop } from 'lodash';
import './Text.less';
import { hasSelection } from '@/utils';
import classnames from 'classnames';
import { EditOutlined } from '@ant-design/icons';

type Props = {
  className: string;
  value: string;
  onChange: (value: string) => void;
  onAfterChange: () => void;
  setFieldsValueChanged: () => void;
  label: string;
  empty: string;
  placeholder: string;
  style: React.CSSProperties;
  readWrite: boolean;
  readOnly: boolean;
  autoFocus: boolean;
  onBlur?: () => void;
  bordered: boolean;
  id: string;
};

export default function Text({
  className,
  value,
  onChange,
  onAfterChange = noop,
  setFieldsValueChanged = noop,
  label,
  empty = '',
  placeholder,
  style,
  readWrite = false,
  readOnly,
  autoFocus,
  onBlur = noop,
  bordered,
  id, // 表单自动注入
}: Props) {
  const [editMode, setEditMode] = useState(false);
  const hasChange = useRef(false);
  const [innerValue, setInnerValue] = useState(value);
  const compositionInput = useRef(false);
  useEffect(() => {
    setInnerValue(value);
  }, [value]);
  if (readOnly) {
    if (value) {
      return value;
    }
    return empty || null;
  }

  if (readWrite && !editMode) {
    return (
      <div
        className={classnames('field-text read-edit', className)}
        onClick={() => {
          if (hasSelection()) {
            return;
          }
          setEditMode(true);
        }}
      >
        <input
          id={id}
          onFocus={() => setEditMode(true)}
          style={{ position: 'absolute', visibility: 'hidden', width: 0, height: 0 }}
        />
        <div className="content">{value || empty}</div>

        <div className="edit-btn">
          <EditOutlined />
        </div>
      </div>
    );
  }

  return (
    <Input
      id={id}
      bordered={bordered}
      className={classnames(className, 'custom-field-text')}
      autoFocus={autoFocus}
      onChange={(e) => {
        onChange(e.target.value);
        setFieldsValueChanged();
        hasChange.current = true;
      }}
      onBlur={(e) => {
        compositionInput.current = false;
        setEditMode(false);
        onBlur();

        if (hasChange.current) {
          onAfterChange();
          hasChange.current = false;
        }
      }}
      value={value}
      placeholder={'请输入…'}
      allowClear
      style={style}
      onCompositionStart={() => {
        compositionInput.current = true;
      }}
      onCompositionEnd={() => {
        compositionInput.current = false;
      }}
      onPressEnter={(e) => {
        if (!compositionInput.current) {
          // @ts-ignore
          e.target.blur();
        }
      }}
    />
  );
}
